import { UiWallet, getWalletUniqueIdentifier as getId } from '@mysten/dapp-kit-react'

export function getWalletUniqueIdentifier(wallet?: UiWallet) {
  return wallet ? getId(wallet) : undefined
}
